import { createRoute } from "@tanstack/react-router";
import { appAuthRoute } from "./index";
import { checkPermissionsAndRedirect } from "../../helpers/checkPermissions";
import Spinner from "../../components/general/Spinner";

const campaignDoctorRoute = createRoute({
  getParentRoute: () => appAuthRoute,
  path: "campaign-doctor",
  beforeLoad: () =>
    checkPermissionsAndRedirect([
      { feature: "campaignDoctor", action: "READ" },
    ]),
  staticData: {
    breadcrumb: "Doctor (Campaigns)",
  },
  pendingComponent: Spinner,
}).lazy(() =>
  import("./campaignDoctor.lazy").then((d) => d.CampaignDoctorRoute)
);

export default campaignDoctorRoute;
